import { render, staticRenderFns } from "./AudioInputs.vue?vue&type=template&id=4f3e02fe&scoped=true&"
import script from "./AudioInputs.vue?vue&type=script&lang=js&"
export * from "./AudioInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3e02fe",
  null
  
)

export default component.exports